<div class="alert alert-info">
  <h4>Rejection history</h4>
  <ul>
    <li *ngFor="let history of perRound$ | async">
      <strong>Round {{ history.round }}</strong> (rejected at:
      {{ history.date | h3Date }})
      <ul>
        <li *ngIf="history.reasons">
          Api/Manual rejection reasons
          <ul>
            <li *ngFor="let reason of history.reasons">
              {{ reason }}
            </li>
          </ul>
        </li>
        <li *ngIf="history.comments">
          Comments
          <ul>
            <li *ngFor="let commentRecord of history.comments">
              {{ commentRecord.user }} ({{ commentRecord.date | h3Date }}):
              {{ commentRecord.comment }}
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</div>
